module.exports = __webpack_public_path__ + "img/list (2).aec15b23.svg";